import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormHelperText,
  FormLabel,
  Grid,
  MenuItem,
  Select as MuiSelect,
  TextField,
  Tooltip,
  Typography,
  Link,
} from "@mui/material";
import { useFormikContext } from "formik";
import CheckboxWrapper from "modules/Forms/components/checkboxWrapper.component";
import { DatePickerWrapper } from "modules/Forms/components/datePickerWrapper.component";
import {
  CustomFastAsyncSelect,
  CustomFastSelect,
} from "modules/Forms/components/form.legacy.component";
import TextFieldWrapper from "modules/Forms/components/textFIeldWrapper.component";
import { UserScopeComponent } from "modules/User/components/userScopeSelector";
import React, { useContext, useEffect, useMemo } from "react";
import {
  PSL_AT_MARKET,
  PSL_ABOVE_MARKET,
  PSL_PPA_ABOVE_MARKET,
  PSL_LOCAL_VENDOR,
  PSL,
} from "../domains/psl.domain";
import PromoItemsService from "../services/promoItems.service";
import {
  SelectBlank,
  SelectMandatory,
  SelectSoleSource,
  SelectValidated,
  SupplierStatus,
} from "./create.container";
import { useMutation, useQuery } from "@tanstack/react-query";
import ChildrenVendorComp from "../components/ChildrenVendorComp.legacy.component";
import { UserFullScopeComponent } from "modules/User/components/userScopeSelector/userFullScopeComponent";
import { useActiveUser, useActiveUserScope } from "modules/User/activeUser";
import { IUserRole } from "modules/User/service/user";
import { toast } from "react-toastify";
import { useStaticData } from "modules/MasterData/service/staticData.hooks";
import { CloudUploadOutlined } from "@mui/icons-material";
import { AttachmentsTable } from "../components/AttachmentsTable";
import { stepContext } from "modules/Forms/components/formikStepperProvider.component";
import { UserService } from "modules/User/service/user.service";

export const SUPPLIER_NOT_DEFINED_CODE = 999999999;
const QUALITY_APPROVERS_REPORT_URL =
  "https://app.powerbi.com/Redirect?action=OpenReport&appId=a49ca96a-b318-4f4d-8f48-19cc9e9756a9&reportObjectId=13045269-86ad-47ff-9df8-93d1d1380683&ctid=12a3af23-a769-4654-847f-958f3d479f4a&reportPage=a236caf5364e0006cf49&pbi_source=appShareLink&portalSessionId=83808960-2a78-41b0-9d8e-47f92d238202";

export const CreateStepOneContainer = ({ userScope,
  loadingUserScope, companyCodes
}) => {
  const [supplierScopeDisabled, setSupplierScopeDisabled] = React.useState(true);
  const [buyerRole, setBuyerRole] = React.useState<number | null>(null);
  const [buyerValidated, setBuyerValidated] = React.useState(false);
  const activeUser = useActiveUser();
  const activeUserScope = useActiveUserScope();
  const staticData = useStaticData();
  const { readOnly } = useContext(stepContext)
  const [view, setView] = React.useState<"simple" | "advanced">("simple");
  const { values, setValues, setFieldValue, getFieldMeta, errors } =
    useFormikContext<any>();

  console.log("Formik initial", {
    scope: values.vendor.scope,
    discriminator: values.vendor.discriminator,
    parentId: values.vendor.parentId,
    childSupplierCode: values.vendor.childSupplierCode,
  });
  // const [forceChildCode, setForceChildCode] = React.useState(false);
  const [childrenVendor, setChildrenVendor] =
    React.useState<{ id: number; name: string; companyCodes: string }[]>(null);
  const [absentCompCodesAndAbsentMarkets, setAbsentCompCodesAndAbsentMarkets] =
    React.useState([]);
  const [clearLocation, setClearLocation] = React.useState(false);
  const userFullScope = useMemo(() => {
    return activeUserScope?.scopeTree;
  }, [activeUserScope]);
  const locationCompanyCodes = useMemo(() => {
    return values.vendor.markets
      .map((market) => companyCodes[market.id])
      .concat(values.vendor.companyCodes.map((it) => it.code))
      .join(",");
  }, [companyCodes, values]);

  useEffect(() => {
    if (clearLocation) {
      setClearLocation(false);
    }
  }, [clearLocation]);
  const isSupplier = activeUser.isEditorSupplier();

  useEffect(() => {
    if (
      isSupplier &&
      values.vendor.pslId == null &&
      values.vendor.statusId == null
    ) {
      setFieldValue(
        "vendor.statusId",
        SupplierStatus.MANDATORY
      );
    }
  }, [
    isSupplier,
    values.vendor.pslId,
    values.vendor.statusId,
    setFieldValue,
  ]);

  const buyerRoleInitialized = React.useRef(false);

  useEffect(() => {
    if (buyerRoleInitialized.current) return;

    if (isSupplier) return;

    const role = activeUser.getUserRole();

    if (role == null) return;

    buyerRoleInitialized.current = true;

    applyBuyerRole(role);

  }, [isSupplier]);


  const applyBuyerRole = (role: IUserRole) => {
    console.log("BuyerRole effect fired");
    console.log("Setting scope to", role);

    setBuyerRole(role);
    setBuyerValidated(true);

    if (isEdit && !isChildPsl) {
      return;
    }
    switch (role) {
      // At Market & PPA At Market
      case IUserRole.AT_MARKET:
      case IUserRole.PPA_AT_MARKET:
        // Lock Vendor Type to Local Vendor
        setSupplierScopeDisabled(true);

        setFieldValue("vendor.scope", 3);
        setFieldValue("vendor.discriminator", "PslVendor");

        // User should select the supplier manually
        // Preserve already selected supplier when returning from Step 2
if (
  !values.vendor.pslId &&
  values.vendor.childSupplierCode == null
) {
  setFieldValue("vendor.childSupplierCode", null);
  setFieldValue("vendor.childSupplierName", null);
}

        break;

      // Above Market & PPA Above Market
      case IUserRole.ABOVE_MARKET:
      case IUserRole.PPA_ABOVE_MARKET:
        setSupplierScopeDisabled(false);

        setFieldValue("vendor.discriminator", "PslVendor");

        // Only initialize once
        if (values.vendor.scope == null) {
          setFieldValue("vendor.scope", 1);
        }

        break;

      default:
        setSupplierScopeDisabled(true);
        setBuyerValidated(false);
        throw new Error("Invalid Buyer Role");
    }

    console.log("applyBuyerRole()", {
      role,
      buyerValidated: true,
      supplierScopeDisabled:
        role === IUserRole.AT_MARKET ||
        role === IUserRole.PPA_AT_MARKET,
      scope:
        role === IUserRole.AT_MARKET ||
          role === IUserRole.PPA_AT_MARKET
          ? 3
          : 1,
    });
  };

  const pslClass = useMemo(() => {
    return new PSL(values.vendor);
  }, [values]);

  const isChildPsl = pslClass.isChildPsl();

  const canAccessQualityApproverLink =
    activeUser.isAtMarketOnly();



  // const vendorType = useMemo(() => {
  //   // Existing catalogue
  //   if (values.vendor.pslId && values.vendor.pslIdWithPrefix) {
  //     if (values.vendor.pslIdWithPrefix.startsWith("LP"))
  //       return { value: 3, label: "Local Vendor" };

  //     if (values.vendor.pslIdWithPrefix.startsWith("CP"))
  //       return { value: 2, label: "Child Vendor" };

  //     return { value: 1, label: "Parent Vendor" };
  //   }

  //   // Existing Create logic
  //   if (values.vendor.scope === 3)
  //     return { value: 3, label: "Local Vendor" };

  //   if (values.vendor.scope === 1)
  //     return { value: 1, label: "Parent Vendor" };

  //   return null;
  // }, [
  //   values.vendor.pslId,
  //   values.vendor.pslIdWithPrefix,
  //   values.vendor.scope,
  // ]);

  const vendorType = useMemo(() => {
    // Existing catalogue
    if (values.vendor.pslId && values.vendor.pslIdWithPrefix) {
      const prefix = values.vendor.pslIdWithPrefix;

      if (prefix.startsWith("LP"))
        return { value: 3, label: "Local Vendor" };

      if (prefix.startsWith("CP") || prefix.startsWith("OW_CP"))
        return { value: 2, label: "Child Vendor" };

      if (prefix.startsWith("PP") || prefix.startsWith("OW_PP"))
        return { value: 1, label: "Parent Vendor" };

      return { value: 1, label: "Parent Vendor" };
    }

    // Create flow
    if (values.vendor.scope === 3)
      return { value: 3, label: "Local Vendor" };

    if (values.vendor.scope === 1)
      return { value: 1, label: "Parent Vendor" };

    return null;
  }, [
    values.vendor.pslId,
    values.vendor.pslIdWithPrefix,
    values.vendor.scope,
  ]);

  // const prefix = useMemo(() => {
  //   // Existing catalogue -> always trust backend prefix
  //   if (values.vendor.pslId && values.vendor.pslIdWithPrefix) {
  //     return values.vendor.pslIdWithPrefix.substring(0, 2);
  //   }

  //   // Create flow -> keep existing behaviour
  //   return vendorType?.value === 3 ? "LP" : "PP";
  // }, [
  //   values.vendor.pslId,
  //   values.vendor.pslIdWithPrefix,
  //   vendorType,
  // ]);
  const prefix = useMemo(() => {
    if (values.vendor.pslId && values.vendor.pslIdWithPrefix) {
      const prefix = values.vendor.pslIdWithPrefix;

      if (prefix.startsWith("LP")) return "LP";
      if (prefix.startsWith("CP") || prefix.startsWith("OW_CP")) return "CP";
      if (prefix.startsWith("PP") || prefix.startsWith("OW_PP")) return "PP";

      return "PP";
    }

    return vendorType?.value === 3 ? "LP" : "PP";
  }, [
    values.vendor.pslId,
    values.vendor.pslIdWithPrefix,
    vendorType,
  ]);

  const vendorLabel =
    prefix === "LP"
      ? "Local"
      : prefix === "CP"
        ? "Child"
        : "Parent";
  const isLocalVendor = vendorType?.value === 3;
  const isParentPsl = !isChildPsl && !isLocalVendor;
  // const isChildVendor = vendorType?.value === 2;
  const isEdit = values.vendor.pslId != null;

  const isAboveMarket =
    buyerRole === IUserRole.ABOVE_MARKET ||
    buyerRole === IUserRole.PPA_ABOVE_MARKET;

  const isCpEdit =
    isEdit &&
    isChildPsl &&
    !isLocalVendor;

  //const disableCPFields = isCpEdit;
  const disableCPFields =
    isEdit &&
    isChildPsl &&
    !isLocalVendor &&
    !isSupplier;

  const supplierOptions = useMemo(() => {
    const options =
      values.vendor.scope === 1
        ? [...(activeUser.getParentSuppliers() ?? [])]
        : [...(activeUser.geChildrenSuppliers() ?? [])];

    // Current supplier from the catalogue
    const supplierId =
      values.vendor.childSupplierCode ??
      values.vendor.parentCode ??
      values.vendor.parentId?.supplierCode ??
      values.vendor.supplierCode;

    const supplierName =
      values.vendor.childSupplierName ??
      values.vendor.parentName ??
      values.vendor.parentId?.supplierName ??
      values.vendor.supplierName;

    if (
      supplierId &&
      !options.some(
        (x) => String(x.supplierId) === String(supplierId)
      )
    ) {
      options.unshift({
        supplierId,
        name: supplierName ?? "",
      });
    }

    return options;
  }, [
    activeUser,
    values.vendor.scope,
    values.vendor.childSupplierCode,
    values.vendor.childSupplierName,
    values.vendor.parentCode,
    values.vendor.parentName,
    values.vendor.supplierCode,
    values.vendor.supplierName,
  ]);

  const isPslEditingDisabled = useMemo(() => {
    if (isChildPsl && !isLocalVendor) {
      return !(
        activeUser.hasAboveMarketRole() &&
        (values.vendor.statusId === SupplierStatus.MANDATORY ||
          values.vendor.statusId === SupplierStatus.SOLE_SOURCE)
      );
    }

    // For parent PSLs: disabled if campaign related
    return values.campaignRelated;
  }, [isChildPsl, activeUser, values.vendor.statusId, values.campaignRelated]);
  // const firstChild = (activeUser.geChildrenSuppliers() &&
  //   activeUser.geChildrenSuppliers()[0]) ?? { supplierId: null, name: null };
  // const firstParent = (activeUser.getParentSuppliers() &&
  //   activeUser.getParentSuppliers()[0]) ?? { supplierId: null, name: null };

  const isLocationEmpty = useMemo(() => {
    return (
      values.vendor.companyCodes?.length === 0 &&
      values.vendor.markets?.length === 0 &&
      values.vendor.zones?.length === 0
    );
  }, [values.vendor.companyCodes, values.vendor.markets, values.vendor.zones]);

  const disableSupplierLookup =
    !isSupplier &&
    isParentPsl &&
    isLocationEmpty;

  const { mutateAsync: uploadPromoHeaderMedia, isPending } = useMutation<
    any,
    any,
    any
  >({
    mutationKey: ["uploadPromoHeaderMedia"],
    mutationFn: async (data) =>
      await PromoItemsService.uploadPromoHeaderMedia(data),
  });

  const { mutateAsync: deletePromoHeaderMedia, isPending: isDeleting } =
    useMutation<any, any, any>({
      mutationKey: ["deletePromoMedia"],
      mutationFn: async (fileId) => {
        await PromoItemsService.deletePromoMaterialMedia({ fileId });
        return fileId;
      },
    });

  const disableSupplierEdit =
    readOnly ||
    (isSupplier && values.vendor.pslId !== null);



  const disableFieldsForCreate =
    readOnly ||
    values.campaignRelated ||
    (
      values.vendor.pslId !== null &&
      isChildPsl &&
      !isLocalVendor
    );
  const allowCpEditableFields =
    isEdit &&
    isChildPsl &&
    !isLocalVendor &&
    (
      activeUser.hasAboveMarketRole() ||
      activeUser.isAtMarket()
    );

  const disableEditableFields = disableFieldsForCreate;


  console.log("Disable Debug", {
    isSupplier,
    pslId: values.vendor.pslId,
    disableSupplierEdit,
    readOnly,
  });


  const childSupplierIdentifier =
    values.vendor.childSupplierCode ||
    values.vendor.parentCode ||
    values.vendor.parentId?.supplierCode ||
    values.vendor.supplierCode;

  useEffect(() => {
    const hasLocation =
      !!locationCompanyCodes || values.vendor.zones?.length > 0;

    if (
      isLocalVendor ||
      !childSupplierIdentifier ||
      !hasLocation
    ) {
      return;
    }

    PromoItemsService.fetchChildrenSuppliersV2({
      locationCompanyCodes,
      childrenOf: childSupplierIdentifier,
      parentId: values.vendor.pslId,
      zones: values.vendor.zones?.map((z) => z.id).join(","),
    })
      .then((response) => {
        console.log("Children Vendor Request1", {
          locationCompanyCodes,
          markets: values.vendor.markets,
          companyCodes: values.vendor.companyCodes.map((c) => c.code),
          zones: values.vendor.zones,
          childrenOf: childSupplierIdentifier,
          parentId: values.vendor.pslId,
        });

        console.log("Children Vendor Response2", response.results);

        response.results.forEach((vendor) => {
          console.log("Vendor", {
            id: vendor.id,
            name: vendor.name,
            companyCodes: vendor.companyCodes,
            companyCodeArray: vendor.companyCodes?.split(","),
          });
        });

        setChildrenVendor(response.results);
      })
      .catch((err) => {
        toast.error(err);
      });
  }, [
    locationCompanyCodes,
    userFullScope,
    values.vendor.scope,
    values.vendor.pslId,
    childSupplierIdentifier,
    values.vendor.zones,
    isParentPsl,
    isLocalVendor,
  ]);
  const lastLoadedEmail = React.useRef<string | null>(null);


  // useEffect(() => {
  //   if (!isSupplier) return;

  //   const email = values.vendor.strategicBuyerEmailAddress;


  //   if (!email) {

  //     // Supplier flow - keep existing behaviour
  //     if (isSupplier) {
  //       setBuyerValidated(false);
  //       setBuyerRole(null);
  //       setSupplierScopeDisabled(true);

  //       lastLoadedEmail.current = null;

  //       resetVendorFields();
  //       setClearLocation(true);
  //       return;
  //     }

  //     // Nestlé flow
  //     const role = activeUser.getUserRole();

  //     if (
  //       role === IUserRole.AT_MARKET ||
  //       role === IUserRole.PPA_AT_MARKET
  //     ) {
  //       setBuyerValidated(false);
  //       setBuyerRole(role);

  //       // Keep Local Vendor selected
  //       setSupplierScopeDisabled(true);

  //       if (values.vendor.scope == null) {
  //         setFieldValue("vendor.scope", 3);
  //       }

  //       // DO NOT reset vendor fields
  //       return;
  //     }

  //     // Above Market / PPA Above Market
  //     setBuyerValidated(false);
  //     setBuyerRole(role);
  //     setSupplierScopeDisabled(false);

  //     setFieldValue("vendor.scope", 1);

  //     // DO NOT reset vendor fields
  //     return;
  //   }

  //   if (lastLoadedEmail.current === email) return;

  //   lastLoadedEmail.current = email;

  //   loadBuyerRole(email);

  // }, [isSupplier, values.vendor.strategicBuyerEmailAddress]);

  useEffect(() => {
    if (!isSupplier) return;

    const email = values.vendor.strategicBuyerEmailAddress;

    if (!email) {
      setBuyerValidated(false);
      setBuyerRole(null);
      setSupplierScopeDisabled(true);

      lastLoadedEmail.current = null;

      resetVendorFields();
      setClearLocation(true);
      return;
    }

    if (lastLoadedEmail.current === email) return;

    lastLoadedEmail.current = email;

    loadBuyerRole(email);
  }, [isSupplier, values.vendor.strategicBuyerEmailAddress]);

  const loadBuyerRole = async (email: string) => {
    console.log("loadBuyerRole called", email);

    if (!email) return;

    try {
      const role = await UserService.getUserRoleByEmail(email);

      applyBuyerRole(role);

    } catch (err: any) {
      toast.error(
        err?.response?.data ??
        err?.response?.data?.message ??
        err?.message ??
        "Unable to validate Buyer Email."
      );

      setBuyerValidated(false);
      setBuyerRole(null);
      setSupplierScopeDisabled(true);

      resetVendorFields();
      setClearLocation(true);
      lastLoadedEmail.current = null;
    }
  };

  const resetVendorFields = () => {
    setValues((prev) => ({
      ...prev,
      vendor: {
        ...prev.vendor,

        strategicBuyerEmailAddress: "",

        scope: null,
        childSupplierCode: null,
        childSupplierName: null,

        teamName: "",
        qualityApprovers: [],

        zones: [],
        markets: [],
        companyCodes: [],

        spendCat1Id: null,
        spendCat1Name: null,

        incoTerms: null,

        businessUnits: [],

        yearlySpend: null,
        yearlySpendCurrencyCode: "",

        validTo: null,

        priceList: "",
        //statusId: null,
        statusId: isSupplier
          ? SupplierStatus.MANDATORY
          : null,
        statusJustification: "",

      }
    }));

    setChildrenVendor(null);
  };
  console.log("test1", {
    scope: values.vendor.scope,
    parentId: values.vendor,
    childSupplierCode: values.vendor.childSupplierCode,
    discriminator: values.vendor.discriminator,
  });

  console.log("test2", {
    readOnly,
    campaignRelated: values.campaignRelated,
    isChildPsl,
    isSupplier,
    disableSupplierEdit,
    disableEditableFields,
    isPslEditingDisabled,
  });
  console.log("test3", {
    pslPrefix: values.vendor.pslIdWithPrefix,
    scope: values.vendor.scope,
    isChildPsl: pslClass.isChildPsl(),
  });
  console.log("test:", {
    readOnly,
    campaignRelated: values.campaignRelated,
    isChildPsl,
    isLocalVendor,
    disableEditableFields,
  });

  useEffect(() => {
    console.log("Location values", {
      zones: values.vendor.zones,
      markets: values.vendor.markets,
      companyCodes: values.vendor.companyCodes,
    });
  }, [
    values.vendor.zones,
    values.vendor.markets,
    values.vendor.companyCodes,
  ]);

  console.log("test4", {
    scope: values.vendor.scope,
    discriminator: values.vendor.discriminator,
    buyerValidated,
    supplierScopeDisabled,
    isParentPsl,
  });

  console.log("Vendor Type Disabled", {
    readOnly,
    pslId: values.vendor.pslId,
    supplierScopeDisabled,
    role: activeUser.getUserRole(),
  });
  // useEffect(() => {
  //   console.log("Init Effect", {
  //     scope: values.vendor.scope,
  //     isSupplier,
  //     role: activeUser.getUserRole(),
  //   });

  //   if (values.vendor.scope != null) {
  //     console.log("Exited because scope already exists");
  //     return;
  //   }

  //   if (isSupplier) {
  //     console.log("Exited because supplier");
  //     return;
  //   }

  //   console.log("Calling applyBuyerRole");
  //   applyBuyerRole(activeUser.getUserRole());
  // }, []);
  return loadingUserScope ? (
    <>loading...</>
  ) : (
    <Card>
      <CardContent>
        <Grid container spacing={4} alignItems={"flex-start"}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ mt: 4, mb: 1 }} variant="h5">
              Buyer Details
            </Typography>
            <Grid container spacing={2} alignItems={"center"}>
              <Grid item xs={12} sm={4}>
                <FormLabel>Buyer Email*:</FormLabel>
              </Grid>
              <Grid item xs={12} sm={8}>
                <CustomFastAsyncSelect
                  customTooltipMessage={activeUser.userSapPersonaPslOnly === 8 ? "Enter Buyer Email" : ""}
                  onLoadLimit={activeUser.userSapPersonaPslOnly === 8 ? 10 : 4}
                  disabled={
                    readOnly ||
                    (
                      values.vendor.pslId !== null &&
                      isChildPsl
                    )
                  }
                  onLoad={async (searchTerm) => {
                    const result = await PromoItemsService.fetchUserEmails({
                      searchTerm,
                    });
                    return result.map((v) => ({
                      value: v,
                      label: v,
                    }));
                  }}
                  initialValue={
                    values.vendor.strategicBuyerEmailAddress
                      ? {
                        value: values.vendor.strategicBuyerEmailAddress,
                        label: values.vendor.strategicBuyerEmailAddress,
                      }
                      : null
                  }
                  hasError={
                    !!getFieldMeta("vendor.strategicBuyerEmailAddress").error
                  }


                  onChange={async (value) => {
                    const email = value?.value;

                    setFieldValue(
                      "vendor.strategicBuyerEmailAddress",
                      email
                    );

                    if (!email) {
                      lastLoadedEmail.current = null;

                      if (isSupplier) {
                        // Existing Supplier behaviour
                        setBuyerValidated(false);
                        setBuyerRole(null);
                        setSupplierScopeDisabled(true);

                        resetVendorFields();

                        if (isSupplier) {
                          setFieldValue(
                            "vendor.statusId",
                            SupplierStatus.MANDATORY
                          );
                        }

                        setClearLocation(true);
                      } else {
                        // Nestlé behaviour
                        const role = activeUser.getUserRole();

                        setBuyerValidated(false);
                        setBuyerRole(role);

                        if (isEdit && !isChildPsl) {
                          setBuyerValidated(false);
                          setBuyerRole(role);
                          return;
                        }
                        if (
                          role === IUserRole.AT_MARKET ||
                          role === IUserRole.PPA_AT_MARKET
                        ) {
                          // Keep Local Vendor selected
                          setSupplierScopeDisabled(true);
                          setFieldValue("vendor.scope", 3);
                        } else {
                          // Above Market / PPA Above Market
                          setSupplierScopeDisabled(false);
                          setFieldValue("vendor.scope", 1);
                        }

                        // DO NOT reset vendor fields
                        // DO NOT clear location
                      }

                      return;
                    }

                  }}
                />
                {!!getFieldMeta("vendor.strategicBuyerEmailAddress").error && (
                  <FormHelperText error>
                    {getFieldMeta("vendor.strategicBuyerEmailAddress").error}
                  </FormHelperText>
                )}
              </Grid>
              {values.vendor.parentId > 0 &&
                values.vendor.scope === PSL_AT_MARKET && (
                  <>
                    <Grid item xs={12} sm={4}>
                      <FormLabel>Market Contact Name:</FormLabel>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <CustomFastAsyncSelect
                        disabled={
                          readOnly ||
                          (disableEditableFields && !allowCpEditableFields)
                        }
                        onLoad={async (searchTerm) => {
                          const result =
                            await PromoItemsService.fetchUserEmails({
                              searchTerm,
                            });
                          return result.map((v) => ({
                            value: v,
                            label: v,
                          }));
                        }}
                        onLoadLimit={4}
                        initialValue={
                          values.vendor.marketContactName
                            ? {
                              value: values.vendor.marketContactName,
                              label: values.vendor.marketContactName,
                            }
                            : null
                        }
                        hasError={
                          !!getFieldMeta("vendor.marketContactName").error
                        }
                        onChange={(value) => {
                          setFieldValue(
                            "vendor.marketContactName",
                            value?.value
                          );
                        }}
                      />
                      {!!getFieldMeta("vendor.marketContactName").error && (
                        <FormHelperText error>
                          {getFieldMeta("vendor.marketContactName").error}
                        </FormHelperText>
                      )}
                    </Grid>
                  </>
                )}
              <Grid item xs={12} sm={4}>
                <FormLabel>Team Name*:</FormLabel>
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextFieldWrapper
                  //disabled={disableEditableFields}
                  disabled={
                    disableEditableFields ||
                    disableCPFields
                  }
                  error={!!getFieldMeta("vendor.teamName").error}
                  name="vendor.teamName"
                  fullWidth
                  size="small"
                  helperText={getFieldMeta("vendor.teamName").error}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <FormLabel>
                  {canAccessQualityApproverLink ? (
                    <>
                      <Link
                        href={QUALITY_APPROVERS_REPORT_URL}
                        title="View Quality Approvers List"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ fontWeight: "inherit" }}
                      >
                        Quality Approvers
                      </Link>
                      :
                    </>
                  ) : (
                    "Quality Approver:"
                  )}
                </FormLabel>
              </Grid>
              <Grid item xs={12} sm={8}>

                <CustomFastAsyncSelect
                  isMulti
                  customTooltipMessage={
                    activeUser.userSapPersonaPslOnly === 8 ? "Enter Approver Email" : ""
                  }
                  onLoadLimit={activeUser.userSapPersonaPslOnly === 8 ? 10 : 4}
                  onLoad={async (searchTerm) => {
                    const result = await PromoItemsService.fetchUserEmails({ searchTerm });
                    return result.map((v) => ({ value: v, label: v }));
                  }}
                  initialValue={
                    Array.isArray(values.vendor.qualityApprovers)
                      ? values.vendor.qualityApprovers.map((email) => ({
                        value: email,
                        label: email,
                      }))
                      : []
                  }
                  hasError={!!getFieldMeta("vendor.qualityApprovers").error}
                  onChange={(values) => {
                    setFieldValue(
                      "vendor.qualityApprovers",
                      values ? values.map((v) => v.value) : []
                    );
                  }}
                  disabled={
                    readOnly ||
                    (disableEditableFields && !allowCpEditableFields)
                  }
                />

              </Grid>
            </Grid>
            <Typography sx={{ mt: 4, mb: 1 }} variant="h5">
              Supplier Details
            </Typography>
            <Grid container spacing={2} alignItems={"flex-start"}>
              {isSupplier ? (
                <>
                  <Grid item xs={12} sm={4}>

                    <CustomFastSelect
                      isMulti={false}
                      disabled={
                        disableSupplierEdit ||
                        readOnly ||
                        supplierScopeDisabled
                      }
                      clearable={false}
                      hasError={!!getFieldMeta("vendor.scope").error}
                      initialValue={vendorType}
                      options={[
                        { value: 1, label: "Parent Vendor" },
                        { value: 3, label: "Local Vendor" },
                      ]}
                      onChange={(value) => {
                        setFieldValue("vendor.scope", value?.value);
                        setFieldValue("vendor.childSupplierCode", null);
                        setFieldValue("vendor.childSupplierName", null);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <CustomFastSelect
                      clearable={false}

                      disabled={
                        !!values.vendor.pslId ||
                        readOnly ||
                        !buyerValidated
                      }
                      hasError={
                        !!getFieldMeta("vendor.childSupplierCode").error
                      }
                      // options={
                      //   values.vendor.scope === 1
                      //     ? activeUser.getParentSuppliers()
                      //     : activeUser.geChildrenSuppliers()
                      // }
                      options={supplierOptions}

                      customDisplay={(option) =>
                        `${option.supplierId} - ${option.name}`
                      }

                      // initialValue={
                      //   values.vendor.childSupplierCode
                      //     ? {
                      //       supplierId: values.vendor.childSupplierCode,
                      //       name: values.vendor.childSupplierName,
                      //     }
                      //     : null
                      // }
                      initialValue={
                        values.vendor.childSupplierCode
                          ? {
                              supplierId: values.vendor.childSupplierCode,
                              name: values.vendor.childSupplierName,
                            }
                          : values.vendor.pslId &&
                            values.vendor.parentCode
                          ? {
                              supplierId: values.vendor.parentCode,
                              name: values.vendor.parentName,
                            }
                          : null
                      }
                      onChange={(value) =>
                        setValues({
                          ...values,
                          vendor: {
                            ...values.vendor,
                            ...{
                              childSupplierCode: value?.supplierId,
                              childSupplierName: value?.name,
                            },
                          },
                        })
                      }
                    />
                  </Grid>
                  {!!childrenVendor && !isLocalVendor && (
                    <>
                      <Grid item xs={12} sm={4} style={{ marginBottom: 10 }}>
                        <span>Children Vendor:</span>
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <ChildrenVendorComp
                          userFullScope={userFullScope}
                          zonesFromPsl={values.vendor.zones}
                          marketsFromPsl={values.vendor.markets}
                          companyCodesFromPsl={values.vendor.companyCodes}
                          childrenVendor={childrenVendor}
                          setAbsentCompCodesAndAbsentMarkets={
                            setAbsentCompCodesAndAbsentMarkets
                          }
                        />
                      </Grid>
                    </>
                  )}
                </>
              ) : isParentPsl ? (
                <>
                  <Grid item xs={12} sm={4}>
                    <CustomFastSelect
                      isMulti={false}
                      clearable={false}
                      hasError={!!getFieldMeta("vendor.scope").error}
                      disabled={
                        readOnly ||
                        !!values.vendor.pslId ||
                        supplierScopeDisabled
                      }
                      initialValue={vendorType}
                      options={[
                        { value: 1, label: "Parent Vendor" },
                        // { value: 2, label: "Child Vendor" },
                        { value: 3, label: "Local Vendor" },
                      ]}
                      onChange={(value) => {
                        console.log("Vendor Scope Changed", value);

                        setValues((prev) => ({
                          ...prev,
                          vendor: {
                            ...prev.vendor,
                            scope: value?.value,
                            childSupplierCode: null,
                            childSupplierName: null,
                          },
                        }));
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <CustomFastAsyncSelect
                      onLoad={(searchTerm) => {
                        if (values.vendor.scope !== 3) {
                          return PromoItemsService.getPslAmdrSuppliersHierarchy(
                            {
                              searchTerm,
                            }
                          ).then((results) => {
                            results.push({
                              id: SUPPLIER_NOT_DEFINED_CODE,
                              name: "Supplier Not Defined",
                            });
                            return results;
                          });
                        }
                        return PromoItemsService.getPslAmdrSuppliers({
                          searchTerm,
                          locationCompanyCodes: locationCompanyCodes,
                          isCreatePSL: values.vendor.pslId === null,
                        }).then((results) => {
                          results.push({
                            id: SUPPLIER_NOT_DEFINED_CODE,
                            name: "Supplier Not Defined",
                          });
                          return results;
                        });
                      }}
                      onLoadLimit={3}
                      disabled={
                        readOnly ||
                        !!values.vendor.pslId ||
                        (isSupplier ? !buyerValidated : disableSupplierLookup)
                      }
                      // disabled={
                      //   readOnly ||
                      //   !!values.vendor.pslId ||
                      //   (
                      //     isSupplier
                      //       ? !buyerValidated
                      //       : false
                      //   )
                      // }
                      hasError={
                        !!getFieldMeta("vendor.childSupplierCode").error
                      }
                      customDisplay={(option) =>
                        `${option.id} - ${option.name}`
                      }
                      initialValue={
                        values.vendor.childSupplierCode && !isLocationEmpty
                          ? {
                            id: values.vendor.childSupplierCode,
                            name: values.vendor.childSupplierName,
                          }
                          : null
                      }
                      onChange={(value) =>
                        setValues({
                          ...values,
                          vendor: {
                            ...values.vendor,
                            ...(value?.id === SUPPLIER_NOT_DEFINED_CODE
                              ? {
                                childSupplierCode: value?.id,
                                childSupplierName: value?.name,
                                statusId: 4,
                              }
                              : {
                                childSupplierCode: value?.id,
                                childSupplierName: value?.name,
                              }),
                          },
                        })
                      }
                    />
                  </Grid>
                  {!!childrenVendor && (
                    <>
                      <Grid item xs={12} sm={4} style={{ marginBottom: 10 }}>
                        <span>Children Vendor:</span>
                      </Grid>
                      <Grid item xs={12} sm={8}>
                        <ChildrenVendorComp
                          userFullScope={userFullScope}
                          zonesFromPsl={values.vendor.zones}
                          marketsFromPsl={values.vendor.markets}
                          companyCodesFromPsl={values.vendor.companyCodes}
                          childrenVendor={childrenVendor}
                          setAbsentCompCodesAndAbsentMarkets={
                            setAbsentCompCodesAndAbsentMarkets
                          }
                        />
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Grid item xs={12} sm={4}>
                    {/* <FormLabel>
                      {prefix === "LP" ? "Local " : "Parent "}
                      Vendor*:
                    </FormLabel> */}
                    <FormLabel>
                      {vendorLabel} Vendor*:
                    </FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <CustomFastAsyncSelect
                      onLoad={(searchTerm) => {
                        return PromoItemsService.getPslAmdrSuppliers({
                          searchTerm,
                          locationCompanyCodes: locationCompanyCodes,
                          isCreatePSL: values.vendor.pslId === null,
                        }).then((results) => {
                          results.push({
                            id: SUPPLIER_NOT_DEFINED_CODE,
                            name: "Supplier Not Defined",
                          });
                          return results;
                        });
                      }}
                      onLoadLimit={3}
                      disabled={isLocationEmpty || !!values.vendor.pslId || readOnly}
                      hasError={
                        !!getFieldMeta("vendor.childSupplierCode").error
                      }
                      customDisplay={(option) =>
                        `${option.id} - ${option.name}`
                      }
                      initialValue={
                        values.vendor.childSupplierCode && !isLocationEmpty
                          ? {
                            id: values.vendor.childSupplierCode,
                            name: values.vendor.childSupplierName,
                          }
                          : null
                      }
                      onChange={(value) => {
                        setValues({
                          ...values,
                          vendor: {
                            ...values.vendor,
                            ...(value?.id === SUPPLIER_NOT_DEFINED_CODE
                              ? {
                                childSupplierCode: value?.id,
                                childSupplierName: value?.name,
                                statusId: 4,
                              }
                              : {
                                childSupplierCode: value?.id,
                                childSupplierName: value?.name,
                              }),
                          },
                        });
                      }}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={4}>
                <FormLabel>Supplier Status*:</FormLabel>
              </Grid>
              <Grid item xs={12} sm={8}>

                <CustomFastSelect
                  options={[
                    SelectMandatory,
                    SelectSoleSource,
                    SelectValidated,
                  ]}
                  disabled={
                    readOnly ||
                    isSupplier ||
                    (isEdit && isChildPsl && !isLocalVendor)
                  }
                  menuPosition="fixed"
                  hasError={!!getFieldMeta("vendor.statusId").error}
                  initialValue={
                    {
                      [SupplierStatus.MANDATORY]: SelectMandatory,
                      [SupplierStatus.SOLE_SOURCE]: SelectSoleSource,
                      [SupplierStatus.VALIDATED]: SelectValidated,
                    }[values.vendor.statusId] || SelectBlank
                  }
                  onChange={(value) =>
                    setFieldValue("vendor.statusId", value?.value)
                  }
                />
              </Grid>
              {values.vendor.statusId === SupplierStatus.MANDATORY ||
                values.vendor.statusId === SupplierStatus.SOLE_SOURCE ? (
                <>
                  <Grid item xs={12} sm={4}>
                    <FormLabel>Justification*:</FormLabel>
                  </Grid>
                  <Grid item sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      multiline
                      minRows={3}
                      name="vendor.statusJustification"
                      fullWidth
                      size="small"
                      error={!!getFieldMeta("vendor.statusJustification").error}
                      helperText={
                        "For compliance reasons, in case you selected “Mandatory” or “Sole Source” status, please justify the rationale and/or attach an evidence such as your sourcing summary or justification signed by your manager (you can attach more than one documents if necessary)"
                      }
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
              {view === "advanced" && (
                <>
                  <Grid item xs={12} sm={4}>
                    <FormLabel>Attachments:</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Button
                      component="label"
                      size="small"
                      variant="contained"
                      color="primary"
                      startIcon={<CloudUploadOutlined />}
                      disabled={
                        isPending ||
                        readOnly ||
                        (disableEditableFields && !allowCpEditableFields)
                      }
                    >
                      <input
                        type="file"
                        hidden
                        onChange={(e) =>
                          uploadPromoHeaderMedia({
                            file: e.target.files[0],
                            promoId: values.vendor.pslId,
                          })
                            .then((response) => {
                              setFieldValue(
                                "vendor.headerFiles",
                                values.vendor.headerFiles.concat(response)
                              );
                            })
                            .catch((err) => {
                              console.error(err);
                            })
                        }
                      />
                      {isPending ? <CircularProgress size={18} /> : "Upload"}
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <AttachmentsTable
                      mediaFiles={values.vendor.headerFiles}
                      onDelete={(mediaId) => {
                        deletePromoHeaderMedia(mediaId).then(
                          (deletedFileId) => {
                            setFieldValue(
                              "vendor.headerFiles",
                              values.vendor.headerFiles.filter(
                                (f) => f.fileId !== deletedFileId
                              )
                            );
                          }
                        );
                      }}
                      deleting={isDeleting}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormLabel>Sup. Contact Name:</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      name="vendor.pslVendorContactName"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormLabel>Supplier Website:</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      name="vendor.pslVendorContactUrl"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormLabel>Sup. Email Address:</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      name="vendor.pslVendorContactEmail"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormLabel>Sup. Phone Number:</FormLabel>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      name="vendor.pslVendorContactPhone"
                      fullWidth
                      size="small"
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" sx={{ mt: 4, mb: 1 }}>
              Scope Definition
            </Typography>
            <Grid container spacing={2} alignItems={"flex-start"}>
              <Grid item xs={12} sm={4}>
                Location*:
              </Grid>
              <Grid item xs={12} sm={8}>
                {isParentPsl ? (
                  <UserFullScopeComponent
                    clear={clearLocation}
                    disableZones={isSupplier}
                    hasError={
                      !!getFieldMeta("vendor.zones").error ||
                      !!getFieldMeta("vendor.markets").error ||
                      !!getFieldMeta("vendor.companyCodes").error
                    }
                    disabled={readOnly ||
                      values.campaignRelated}
                    initialMarkets={values.vendor.markets}
                    initialCompanies={values.vendor.companyCodes}
                    initialZones={values.vendor.zones}
                    onChange={(newValues) => {
                      const withLocation =
                        newValues.zones?.length > 0 ||
                        newValues.markets?.length > 0 ||
                        newValues.companyCodes?.length > 0;
                      setValues({
                        ...values,
                        vendor: {
                          ...values.vendor,
                          zones:
                            newValues.zones?.map((el) => ({
                              id: el.id,
                              name: el.title,
                            })) || [],
                          markets:
                            newValues.markets?.map((el) => ({
                              id: el.id,
                              name: el.title,
                            })) || [],
                          companyCodes:
                            newValues.companyCodes?.map((el) => ({
                              id: el.id,
                              name: el.title,
                              code: el.code,
                            })) || [],
                          childSupplierCode: withLocation
                            ? values.vendor.childSupplierCode
                            : null,
                          childSupplierName: withLocation
                            ? values.vendor.childSupplierName
                            : null,
                        },
                      });
                      if (!withLocation) setChildrenVendor(null);
                    }}
                  />
                ) : (
                  <UserScopeComponent
                    hasError={
                      !!getFieldMeta("vendor.zones").error ||
                      !!getFieldMeta("vendor.markets").error ||
                      !!getFieldMeta("vendor.companyCodes").error
                    }
                    disabled={
                      values.campaignRelated ||
                      (isChildPsl && !isLocalVendor) ||
                      disableSupplierEdit
                    }
                    initialMarkets={values.vendor.markets}
                    initialCompanies={values.vendor.companyCodes}
                    onChange={(newValues) => {
                      const withLocation =
                        newValues.zones?.length > 0 ||
                        newValues.markets?.length > 0 ||
                        newValues.companyCodes?.length > 0;
                      setValues({
                        ...values,
                        vendor: {
                          ...values.vendor,
                          zones:
                            newValues.zones?.map((el) => ({
                              id: el.id,
                              name: el.title,
                            })) || [],
                          markets:
                            newValues.markets?.map((el) => ({
                              id: el.id,
                              name: el.title,
                            })) || [],
                          companyCodes:
                            newValues.companyCodes?.map((el) => ({
                              id: el.id,
                              name: el.title,
                              code: el.code,
                            })) || [],
                          childSupplierCode: withLocation
                            ? values.vendor.childSupplierCode
                            : null,
                          childSupplierName: withLocation
                            ? values.vendor.childSupplierName
                            : null,
                        },
                      });
                      if (!withLocation) setChildrenVendor(null);
                    }}
                    limitedLocation={false}
                  />
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                Spend Category L1*:
              </Grid>
              <Grid item xs={12} sm={8}>
                <CustomFastSelect
                  isMulti={false}
                  disabled={
                    disableEditableFields ||
                    disableCPFields
                  }
                  initialValue={
                    values.vendor.spendCat1Id
                      ? {
                        value: values.vendor.spendCat1Id,
                        label: `[${staticData.spendCategoriesHashMap[
                          values.vendor.spendCat1Id
                        ].code}] ${staticData.spendCategoriesHashMap[
                          values.vendor.spendCat1Id
                        ].name
                          }`,
                      }
                      : null
                  }
                  options={staticData.spendCategories
                    ?.filter((spendCat) => spendCat.active)
                    .map((spendCategory) => ({
                      value: spendCategory.id,
                      label:
                        "[" + spendCategory.code + "] " + spendCategory.name,
                    }))}
                  onChange={(value) => {
                    setFieldValue("vendor.spendCat1Id", value?.value);
                    setFieldValue("vendor.spendCat1Name", value?.label);
                    setFieldValue("materials", []);
                  }}
                  hasError={!!getFieldMeta("vendor.spendCat1Id").error}
                />
                {!!getFieldMeta("vendor.spendCat1Id").error && (
                  <FormHelperText error>
                    {getFieldMeta("vendor.spendCat1Id").error}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={4}>
                Incoterms:
              </Grid>
              <Grid item xs={12} sm={8}>
                <CustomFastSelect
                  isMulti={false}
                  disabled={
                    readOnly ||
                    (disableEditableFields && !allowCpEditableFields)
                  }
                  initialValue={
                    values.vendor.incoTerms
                      ? {
                        value: values.vendor.incoTerms,
                        label:
                          values.vendor.incoTerms +
                          " - " +
                          staticData.incotermsHashMap[
                          values.vendor.incoTerms
                          ] || "",
                      }
                      : null
                  }
                  options={staticData.incoterms.map((incoterm) => ({
                    value: incoterm.id,
                    label: incoterm.id + " - " + incoterm.name,
                  }))}
                  onChange={(value) => {
                    setFieldValue("vendor.incoTerms", value?.value);
                  }}
                  hasError={!!getFieldMeta("vendor.incoTerms").error}
                />
                {!!getFieldMeta("vendor.incoTerms").error && (
                  <FormHelperText error>
                    {getFieldMeta("vendor.incoTerms").error}
                  </FormHelperText>
                )}
              </Grid>
              {view === "advanced" && (
                <>
                  <Grid item xs={12} sm={4}>
                    Business Unit:
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <CustomFastSelect
                      isMulti={true}
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      initialValue={
                        values.vendor.businessUnits?.length > 0
                          ? values.vendor.businessUnits.map((bu) => ({
                            value: bu.id,
                            label: bu.name,
                          }))
                          : null
                      }
                      options={staticData.businessUnits.map((v) => ({
                        value: v.id,
                        label: v.name,
                      }))}
                      onChange={(value) => {
                        setFieldValue(
                          "vendor.businessUnits",
                          value
                            ? value.map((v) => ({
                              id: v.value,
                              name: v.label,
                            }))
                            : null
                        );
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    Yearly Spend Estimation:
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <MuiSelect
                          disabled={
                            disableEditableFields ||
                            disableCPFields
                          }
                          size="small"
                          fullWidth
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={values.vendor.yearlySpendCurrencyCode}
                          label="Age"
                          onChange={(e) =>
                            setFieldValue(
                              "vendor.yearlySpendCurrencyCode",
                              e.target.value
                            )
                          }
                        >
                          {staticData.currencies.map((currency) => {
                            return (
                              <MenuItem key={currency.CurrencyKey} value={currency.CurrencyKey}>
                                {currency.Description}
                              </MenuItem>
                            );
                          })}
                        </MuiSelect>
                      </Grid>
                      <Grid item xs={8}>
                        <TextFieldWrapper
                          disabled={
                            disableEditableFields ||
                            disableCPFields
                          }
                          fullWidth
                          name="vendor.yearlySpend"
                          size="small"
                          type="number"
                          inputProps={{ min: 0 }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    Valid From:
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <DatePickerWrapper
                      name="vendor.validFrom"
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      slotProps={{
                        textField: {
                          size: "small",
                          fullWidth: true,
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={12} sm={4}>
                Valid To*:
              </Grid>
              <Grid item xs={12} sm={8}>
                <DatePickerWrapper
                  name="vendor.validTo"
                  disabled={
                    disableEditableFields ||
                    disableCPFields
                  }
                  slotProps={{
                    textField: {
                      size: "small",
                      fullWidth: true,
                      error: !!getFieldMeta("vendor.validTo").error,
                      helperText: getFieldMeta("vendor.validTo").error,
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                Agreements:
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextFieldWrapper
                  disabled={
                    disableEditableFields ||
                    disableCPFields
                  }
                  name="vendor.agreements"
                  fullWidth
                  size="small"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                Tender Number:
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextFieldWrapper
                  disabled={
                    disableEditableFields ||
                    disableCPFields
                  }
                  name="vendor.tenderNumber"
                  fullWidth
                  size="small"
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                Price List Link:
              </Grid>

              <Grid item xs={12} sm={8}>
                <TextFieldWrapper
                  disabled={
                    disableEditableFields ||
                    disableCPFields
                  }
                  name="vendor.priceList"
                  fullWidth
                  size="small"
                  inputProps={{
                    type: "url",
                    placeholder: "https://www.example.com",
                  }}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sx={{
                  display: view === "advanced" ? "block" : "none",
                  p: 0,
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    Note to Requester:
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      name="vendor.noteRequester"
                      fullWidth
                      size="small"
                    />
                  </Grid>

                  <Grid item xs={12} sm={4}>
                    Note to Local Procurement:
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <TextFieldWrapper
                      disabled={
                        disableEditableFields ||
                        disableCPFields
                      }
                      name="vendor.noteLocalProcurement"
                      fullWidth
                      size="small"
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={4}
                    hidden={
                      !values.pslId ||
                      [
                        PSL_ABOVE_MARKET,
                        PSL_PPA_ABOVE_MARKET,
                        PSL_LOCAL_VENDOR,
                      ].includes(values.vendor.scope)
                    }
                  >
                    EasyBuy:
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={8}
                    hidden={
                      !values.pslId ||
                      [PSL_ABOVE_MARKET, PSL_PPA_ABOVE_MARKET, 3].indexOf(
                        values.vendor.scope
                      ) > -1
                    }
                  >
                    <Tooltip
                      placement="right"
                      title="Tick the box in case you want the PSL form to be pushed to EasyBuy as catalogs"
                    >
                      <CheckboxWrapper
                        name="vendor.relatedToEasyBuy"
                        label="Should be managed in EasyBuy"
                        readOnly={readOnly}
                      />
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2} alignItems={"center"} sx={{ mt: 4 }}>
          <Grid item xs={12}>
            <Button
              fullWidth
              size="large"
              variant="outlined"
              color="primary"
              type="button"
              onClick={() =>
                setView(prev => (prev === "simple" ? "advanced" : "simple"))
              }
            >
              {view === "simple" ? "More details" : "Less Details"}
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CreateStepOneContainer;
